// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-dialog-mask {
  background-color: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  padding: 20px;
}

.RNEdGUPec04UA4XZ {
  border-radius: 16px;
  width: 100% !important;
  max-width: 1000px;
  height: auto;
  background-color: #f3f5f7;
  padding: 40px;
  box-shadow: none;
}

.RNEdGUPec04UA4XZ .p-dialog-header {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: #f3f5f7;
  padding: 0;
  margin-bottom: 32px;
}

.RNEdGUPec04UA4XZ .p-dialog-title {
  color: #303030;
  font-weight: 700;
  font-size: 30px;
}

.RNEdGUPec04UA4XZ .p-dialog-content {
  text-align: center;
  border-radius: 16px;
  height: 408px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 48px;
  border: 1px solid #e2e8f0;
}

.RNEdGUPec04UA4XZ .p-fileupload-buttonbar {
  display: none !important;
}

.RNEdGUPec04UA4XZ .p-fileupload-content {
  padding: 0;
  border: none;
}

.pOFyOPBov6Qne_hY {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.vvP_tnUMXA0s4uzE {
  width: 40px;
  height: 40px;
}

.SaoWQc4Nn5c_UntL {
  margin: 0;
  font-weight: 600;
  font-size: 22px;
  color: #000000;
  margin-bottom: 32px;
}

.Ed1GLZ3508Krg67u span {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
}

.Ed1GLZ3508Krg67u .caYD7bb0LKIVZ7uu {
  color: #379bfa;
  text-decoration: underline;
  cursor: pointer;
  font-size: 22px;
  font-weight: 600;
}

.RNEdGUPec04UA4XZ .p-dialog-footer {
  background-color: #f3f5f7;
  padding: 0;
  display: flex;
  gap: 8px;
}

.RNEdGUPec04UA4XZ .p-dialog-footer button {
  margin: 0;
  width: 100%;
  height: 64px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
}

.BR8Q5e5vNMYsWYpg {
  background-color: #56be4d;
  border-color: #56be4d;
}

.BR8Q5e5vNMYsWYpg:hover {
  background-color: #4eac46;
  border-color: #4eac46;
}

.BR8Q5e5vNMYsWYpg:active {
  background-color: #44963d;
  border-color: #44963d;
}

.BR8Q5e5vNMYsWYpg:focus {
  box-shadow: none;
}

.BR8Q5e5vNMYsWYpg:focus-visible {
  box-shadow: 0 0 0 0.2rem #4eac46;
}

.UeTsPN6AfnwxxZWG {
  background-color: #e1e7ed;
  border-color: #e1e7ed;
  color: #303030;
}

.UeTsPN6AfnwxxZWG:hover {
  background-color: #d5dce3;
  border-color: #d5dce3;
}

.UeTsPN6AfnwxxZWG:active {
  background-color: #c7cfd7;
  border-color: #c7cfd7;
}

.UeTsPN6AfnwxxZWG:focus {
  box-shadow: none;
}

.UeTsPN6AfnwxxZWG:focus-visible {
  box-shadow: 0 0 0 0.2rem #beccd2;
}

.RNEdGUPec04UA4XZ .p-progressbar {
  display: none;
}


/* Media Breakpoints */

/* Tablet */
@media screen and (max-width: 769px) {
  .RNEdGUPec04UA4XZ {
    padding: 24px;
  }
}


/* Mobile */
@media screen and (max-width: 480px) {
  .RNEdGUPec04UA4XZ .p-dialog-header {
    margin-bottom: 24px;
  }

  .RNEdGUPec04UA4XZ .p-dialog-title {
    font-size: 22px;
  }

  .RNEdGUPec04UA4XZ .p-dialog-content {
    margin-bottom: 24px;
    height: 310px;
  }

  .RNEdGUPec04UA4XZ .p-dialog-footer {
    flex-direction: column;
  }

  .RNEdGUPec04UA4XZ .p-dialog-footer button {
    height: 47px;
  }

  .vvP_tnUMXA0s4uzE {
    width: 32px;
    height: 32px;
  }

  .pOFyOPBov6Qne_hY {
    gap: 16px;
  }

  .SaoWQc4Nn5c_UntL {
    margin-bottom: 24px;
  }

  .SaoWQc4Nn5c_UntL,
  .Ed1GLZ3508Krg67u .caYD7bb0LKIVZ7uu {
    font-size: 18px;
  }

  .Ed1GLZ3508Krg67u span {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ImportModal/ImportModal.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;;AAGA,sBAAsB;;AAEtB,WAAW;AACX;EACE;IACE,aAAa;EACf;AACF;;;AAGA,WAAW;AACX;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[":global(.p-dialog-mask) {\r\n  background-color: rgba(0, 0, 0, 0.35);\r\n  backdrop-filter: blur(10px);\r\n  padding: 20px;\r\n}\r\n\r\n.importModal {\r\n  border-radius: 16px;\r\n  width: 100% !important;\r\n  max-width: 1000px;\r\n  height: auto;\r\n  background-color: #f3f5f7;\r\n  padding: 40px;\r\n  box-shadow: none;\r\n}\r\n\r\n.importModal :global(.p-dialog-header) {\r\n  border-top-left-radius: 16px;\r\n  border-top-right-radius: 16px;\r\n  background-color: #f3f5f7;\r\n  padding: 0;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.importModal :global(.p-dialog-title) {\r\n  color: #303030;\r\n  font-weight: 700;\r\n  font-size: 30px;\r\n}\r\n\r\n.importModal :global(.p-dialog-content) {\r\n  text-align: center;\r\n  border-radius: 16px;\r\n  height: 408px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  margin-bottom: 48px;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.importModal :global(.p-fileupload-buttonbar) {\r\n  display: none !important;\r\n}\r\n\r\n.importModal :global(.p-fileupload-content) {\r\n  padding: 0;\r\n  border: none;\r\n}\r\n\r\n.uploadContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 24px;\r\n}\r\n\r\n.uploadIcon {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.importModalText {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  font-size: 22px;\r\n  color: #000000;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.importModalTextContent span {\r\n  font-size: 18px;\r\n  color: rgba(0, 0, 0, 0.5);\r\n  font-weight: 500;\r\n}\r\n\r\n.importModalTextContent .chooseLink {\r\n  color: #379bfa;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n}\r\n\r\n.importModal :global(.p-dialog-footer) {\r\n  background-color: #f3f5f7;\r\n  padding: 0;\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.importModal :global(.p-dialog-footer) button {\r\n  margin: 0;\r\n  width: 100%;\r\n  height: 64px;\r\n  border-radius: 16px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.importModalBtnUpload {\r\n  background-color: #56be4d;\r\n  border-color: #56be4d;\r\n}\r\n\r\n.importModalBtnUpload:hover {\r\n  background-color: #4eac46;\r\n  border-color: #4eac46;\r\n}\r\n\r\n.importModalBtnUpload:active {\r\n  background-color: #44963d;\r\n  border-color: #44963d;\r\n}\r\n\r\n.importModalBtnUpload:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.importModalBtnUpload:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem #4eac46;\r\n}\r\n\r\n.importModalBtnCancel {\r\n  background-color: #e1e7ed;\r\n  border-color: #e1e7ed;\r\n  color: #303030;\r\n}\r\n\r\n.importModalBtnCancel:hover {\r\n  background-color: #d5dce3;\r\n  border-color: #d5dce3;\r\n}\r\n\r\n.importModalBtnCancel:active {\r\n  background-color: #c7cfd7;\r\n  border-color: #c7cfd7;\r\n}\r\n\r\n.importModalBtnCancel:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.importModalBtnCancel:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem #beccd2;\r\n}\r\n\r\n.importModal :global(.p-progressbar) {\r\n  display: none;\r\n}\r\n\r\n\r\n/* Media Breakpoints */\r\n\r\n/* Tablet */\r\n@media screen and (max-width: 769px) {\r\n  .importModal {\r\n    padding: 24px;\r\n  }\r\n}\r\n\r\n\r\n/* Mobile */\r\n@media screen and (max-width: 480px) {\r\n  .importModal :global(.p-dialog-header) {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .importModal :global(.p-dialog-title) {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .importModal :global(.p-dialog-content) {\r\n    margin-bottom: 24px;\r\n    height: 310px;\r\n  }\r\n\r\n  .importModal :global(.p-dialog-footer) {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .importModal :global(.p-dialog-footer) button {\r\n    height: 47px;\r\n  }\r\n\r\n  .uploadIcon {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  .uploadContent {\r\n    gap: 16px;\r\n  }\r\n\r\n  .importModalText {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .importModalText,\r\n  .importModalTextContent .chooseLink {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .importModalTextContent span {\r\n    font-size: 14px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var importModal = `RNEdGUPec04UA4XZ`;
export var uploadContent = `pOFyOPBov6Qne_hY`;
export var uploadIcon = `vvP_tnUMXA0s4uzE`;
export var importModalText = `SaoWQc4Nn5c_UntL`;
export var importModalTextContent = `Ed1GLZ3508Krg67u`;
export var chooseLink = `caYD7bb0LKIVZ7uu`;
export var importModalBtnUpload = `BR8Q5e5vNMYsWYpg`;
export var importModalBtnCancel = `UeTsPN6AfnwxxZWG`;
export default ___CSS_LOADER_EXPORT___;
